import {
  AUTOMATION_ACTIVATED_MANAGED_STEP_KEY,
  AUTOMATION_ACTIVATED_TOUCHLESS_STEP_KEY,
  BRAND_CENTER_SAVED_STEP_KEY,
  CAMPAIGN_SENT_MANAGED_STEP_KEY,
  CAMPAIGN_SENT_TOUCHLESS_STEP_KEY,
  COMPLIANCE_SETTINGS_COMPLETED_STEP_KEY,
  INFINITY_TESTING_TRIED_STEP_KEY,
  INTEGRATION_ACTIVATED_STEP_KEY,
  POPUP_ACTIVATED_MANAGED_STEP_KEY,
  POPUP_ACTIVATED_TOUCHLESS_STEP_KEY,
  SUBSCRIBERS_IMPORTED_MANAGED_STEP_KEY,
  SUBSCRIBERS_IMPORTED_TOUCHLESS_STEP_KEY,
} from './constants';

// Step Groups
const sharedSteps = [
  BRAND_CENTER_SAVED_STEP_KEY,
  COMPLIANCE_SETTINGS_COMPLETED_STEP_KEY,
  INFINITY_TESTING_TRIED_STEP_KEY,
  INTEGRATION_ACTIVATED_STEP_KEY,
] as const;

// Managed Steps
export const managedSteps = [
  ...sharedSteps,
  AUTOMATION_ACTIVATED_MANAGED_STEP_KEY,
  CAMPAIGN_SENT_MANAGED_STEP_KEY,
  POPUP_ACTIVATED_MANAGED_STEP_KEY,
  SUBSCRIBERS_IMPORTED_MANAGED_STEP_KEY,
] as const;

// Touchless Steps
export const touchlessSteps = [
  ...sharedSteps,
  AUTOMATION_ACTIVATED_TOUCHLESS_STEP_KEY,
  CAMPAIGN_SENT_TOUCHLESS_STEP_KEY,
  POPUP_ACTIVATED_TOUCHLESS_STEP_KEY,
  SUBSCRIBERS_IMPORTED_TOUCHLESS_STEP_KEY,
] as const;
